import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/Typography";
import Div from "components/primitives/Div";
import CheckIcon from "components/Icons/CheckIcon";
import premierLeagueLogo from "./logos/premier-league.png";
import nbaLogo from "./logos/nba.png";
import nflLogo from "./logos/nfl.png";
import ncaaLogo from "./logos/ncaa.png";
import hyrox365Logo from "./logos/hyrox365.png";

const Root = styled(Div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(3),
  width: "100%",
}));

const Strip = styled(Div)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  /**
   * `space-between` spreads the logos edge to edge at the full 1040px content
   * width, matching the design. The column gap is only a floor, and is kept
   * tight deliberately: at the app's narrowest supported content width (~690px,
   * a 961px viewport minus the expanded sidebar and a scrollbar) the logos still
   * fit on one row rather than wrapping a single logo onto a second line.
   */
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(3),
  opacity: 0.75,
  width: "100%",
}));

const Logo = styled("img")({
  display: "block",
  width: "auto",
  objectFit: "contain",
});

const TrustedByRow = styled(Div)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  color: theme.palette.grey[120],

  ".MuiSvgIcon-root": {
    fontSize: "18px",
  },
}));

/**
 * Heights come from the design's logo strip; widths follow each logo's own
 * aspect ratio so the marks stay undistorted. Static, so module scope rather
 * than an empty-dep `useMemo`.
 */
const LOGOS = [
  { src: premierLeagueLogo, alt: "Premier League", height: 44 },
  { src: nbaLogo, alt: "NBA", height: 38 },
  { src: nflLogo, alt: "NFL", height: 60 },
  { src: ncaaLogo, alt: "NCAA", height: 22 },
  { src: hyrox365Logo, alt: "HYROX 365", height: 15 },
];

function UpsellTrustLogos() {
  const { t } = useTranslation();

  return (
    <Root>
      <TrustedByRow>
        <CheckIcon />
        <Typography variant="TextS">{t("upsell.trusted_by_label")}</Typography>
      </TrustedByRow>
      <Strip>
        {LOGOS.map((logo) => (
          <Logo key={logo.alt} src={logo.src} alt={logo.alt} height={logo.height} />
        ))}
      </Strip>
    </Root>
  );
}

export default UpsellTrustLogos;
